import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applicationSummary: {
    applicationName: '',
    domain: '',
    archetype: '',
    riskCode: '',
    riskLevel: '',
    description: '',
    modifiers: [],
  },
  trustAttributes: {
    Accuracy: 0,
    Fairness: 0,
    Security: 0,
    Privacy: 0,
    Robustness: 0,
    Explainability: 0,
    Ethics: 0,
  },
  recommendations: [],
  loading: false,
  error: null,
};

const trustIndexSlice = createSlice({
  name: 'trustIndex',
  initialState,
  reducers: {
    setApplicationSummary: (state, action) => {
      state.applicationSummary = { ...state.applicationSummary, ...action.payload };
    },
    setTrustAttributes: (state, action) => {
      state.trustAttributes = { ...state.trustAttributes, ...action.payload };
    },
    setRecommendations: (state, action) => {
      state.recommendations = action.payload;
    },
    setTrustIndexData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetTrustIndex: () => initialState,
  },
});

export const {
  setApplicationSummary,
  setTrustAttributes,
  setRecommendations,
  setTrustIndexData,
  setLoading,
  setError,
  resetTrustIndex,
} = trustIndexSlice.actions;

export default trustIndexSlice.reducer;
